<template>
  <section ref="element" :class='{fade: active}'>
    <slot />
  </section>
</template>

<script setup>
import { useScroll } from '@vueuse/core'
import { useElementBounding } from '@vueuse/core'

const props = defineProps({
  active: {
    default: true,
  },
  offset: {
    type: Number,
    default: 0,
  },
  threshold: {
    type: Number,
    default: 200,
  },
});

const element = ref();
const {top, height} = useElementBounding(element, { throttle: 100 })
const {y} = useScroll(window, { throttle: 100 })
const intro = computed(() => (window.innerHeight - top.value) < props.threshold ? (window.innerHeight - top.value + props.offset) / props.threshold : 1);
const outro = computed(()=> (top.value + height.value - props.offset) < props.threshold ? (top.value + height.value - props.offset) / props.threshold : 1);
const introOrOutro = computed(()=> intro.value < 1 ? intro.value : outro.value < 1 ? outro.value : 1 );
</script>

<style scoped>
  section.fade {
    opacity: v-bind(introOrOutro);
  }
</style>
